import React, { useCallback } from 'react';

import Hubspot from 'main/common/Hubspot';
import { useUserInfo } from 'queries/user-action/use-user-info';

import PlanSummary from '../Summary';

interface Props {
    className?: string;
}

const FreePlanSummary: React.FC<Props> = ({ className }) => {
    const { data: user } = useUserInfo();

    const onClick = useCallback(() => {
        if (user) {
            Hubspot.send(Hubspot.PRICING_CLICK, { email: user.email });
        }
    }, [user]);

    return (
        <PlanSummary
            name="Free"
            price={{ primary: 'Free', secondary: 'Forever' }}
            button={
                user
                    ? null
                    : {
                          text: 'Sign up',
                          to: '/login',
                          variant: 'outlined',
                          onClick
                      }
            }
            className={className}
        />
    );
};

export default FreePlanSummary;
